import { Form } from "../Abstracts/Form";
import { EntityModalForm } from "../CRUDs/abstracts/mixins/EntityModalForm";
import { Preloader } from "../Common/Preloader";
import { Signature } from "../Common/Signature";
import { Invoice } from "../CRUDs/entities/Invoice";
import { PaymentForm } from "./PaymentForm";

export const ApproveQuoteForm = (() => {

    return class ApproveQuoteForm extends Form {

        constructor(quote, form_container = 'form-container') {
            super('approve-quote-modal', `/customer/quote/${quote.id}/accept`, 'POST');

            this.quote = quote;
            this.formContainer = document.querySelector(`#${form_container}`);
            this.submitBtn = this.formContainer.querySelector('#approve.accept');

            if (this.submitBtn) {
                const hasSignature = this.submitBtn.hasAttribute('data-has-signature');
                this.getSignatureData = Signature.init(hasSignature, {width: 396, height: 190});
                this.listners();
            }

        }

        showSignature() {
            $('#approve-quote-modal').modal('hide');
            $('#signature-modal').modal('show');
        }

        async submit() {
            const signature = this.getSignatureData();
            $('#signature-empty-error').addClass('d-none')
            if(signature === false){
                $('#signature-empty-error').removeClass('d-none')
                setTimeout(()=>{
                    $('#signature-empty-error').addClass('d-none')
                },3000)
                return
            }

            const result = await fetch(this.actionUrl, {
                method: this.method,
                body: JSON.stringify({ signature }),
                headers: { 'Content-Type': 'application/json' }
            });

            const preloader = new Preloader('signature-modal', true);
            preloader.setMessage('Processing');
            preloader.open();

            if (result.ok) this.successCallback(result);
            else this.errorCallback(result);
        }

        async successCallback(result) {
            const data = await result.json();
            $('#signature-modal').modal('hide');
            $('.modal-backdrop').first().remove();

            // Check if quote has deposit and invoice was created - open payment modal
            if (data.invoice_id) {
                // This is a deposit payment - signature saved, invoice created, but quote not approved yet
                // Load payment modal for Invoice (not ServiceInvoice) with deposit amount, but don't show it
                // Then open select_pm-modal directly for payment
                const invoice = new Invoice(data.invoice_id);
                
                console.log('Opening deposit payment for invoice:', data.invoice_id, 'deposit_amount:', data.deposit_amount);
                
                // Ensure signature modal is fully closed
                $('#signature-modal').modal('hide');
                $('.modal-backdrop').remove();
                
                // Load payment modal but don't show it (openModal = false)
                invoice.openModal('payment', {
                    deposit_amount: data.deposit_amount,
                    is_deposit: true
                }, true, false); // isRead=true, openModal=false
                
                // Use polling to check when modal is loaded instead of relying on event
                let attempts = 0;
                const maxAttempts = 50; // 5 seconds max
                
                const checkModalAndOpen = () => {
                    attempts++;
                    const paymentInvoiceModal = $('#payment-invoice-modal');
                    const selectPmModal = $('#select_pm-modal');
                    
                    console.log(`Attempt ${attempts}: payment-invoice-modal:`, paymentInvoiceModal.length, 'select_pm-modal:', selectPmModal.length);
                    
                    if (selectPmModal.length > 0) {
                        console.log('select_pm-modal found in DOM, initializing PaymentForm');
                        
                        // Ensure payment-invoice-modal is hidden
                        paymentInvoiceModal.modal('hide');
                        $('.modal-backdrop').remove();
                        
                        // Initialize PaymentForm which will handle select_pm-modal
                        const paymentForm = new PaymentForm(invoice, 'payment');
                        
                        // Wait a bit for PaymentForm to initialize
                        setTimeout(() => {
                            console.log('Opening select_pm-modal, payment methods count:', $('.payment-method-select .payment-method-row').length);
                            selectPmModal.modal('show');
                        }, 200);
                    } else if (attempts < maxAttempts) {
                        // Retry after 100ms
                        setTimeout(checkModalAndOpen, 100);
                    } else {
                        console.error('select_pm-modal not found after', maxAttempts, 'attempts');
                    }
                };
                
                // Start checking after a short delay
                setTimeout(checkModalAndOpen, 200);
            } else {
                // No deposit - quote approved immediately, show success message
                EntityModalForm.pasteForm(data.modal);
                $('#success-action-modal').modal('show');
                $('.modal').modal('hide');
            }
        }

        async errorCallback(result) {
            $('.modal').modal('hide');
        }

        listners() {
            super.listners()
            this.formContainer.querySelector('#signature-required')?.addEventListener('click', this.showSignature);
            this.formContainer.querySelector('[data-reject]').addEventListener('click', () => {
                const formHTML = this.quote.getForm(this.quote.entityClass, 'reject', this.quote.id);
                $(this.formContainer).append(formHTML);


                const confirmModal = $(this.formContainer).find('#confirm-action-modal');

                confirmModal
                    .modal('show')
                    .find('button[data-confirmation]')
                    .on('click', (e) => {
                        this.quote.changeStatus('rejected');
                        confirmModal.modal('hide');
                        $('#approve-quote-modal').modal('hide');
                        window.location.reload();
                    });
            });
        }

        static init(quote, container, showModal = true) {
            /*const quoteData = quote.read();
            let flag = false;
            const statusList = quote.getStatusList();
            if (quoteData.status == statusList.waiting_approval || quoteData.status == statusList.draft) {
                flag = true;
            }
            if (flag) {*/
                quote.openModal('approve',{}, false, showModal, container);
                return new ApproveQuoteForm(quote, container);
            //}
        }
    }

})();
